<template>
  <div>
    <div class="around-fade"></div>

    <div class="zone-modal">
      <CloseModalButton :on-click="closeBuildingModal"></CloseModalButton>
      <h1>Metryka budynku</h1>
      <div class="forms">
        <div class="row">
          <div class="col-12">
            <InputDropdown :items="voivodeships" v-model="voivodeship" placeholder="Województwo" ref="voivodeshipInput" :readonly="restricted" :class="{'error': errors.includes('voivodeship')}" />
          </div>
          <div class="col-12">
            <InputDropdown ref="countyInput" :items="counties" v-model="county" placeholder="Powiat" :readonly="restricted" :class="{'error': errors.includes('county')}" />
          </div>
          <div class="col-12">
            <InputDropdown ref="communityInput" :items="communities" v-model="community" placeholder="Gmina" :readonly="restricted" :class="{'error': errors.includes('community')}" />
          </div>
          <div class="col-12 col-md-8">
            <InputDropdown ref="cityInput" :items="cities" v-model="city" placeholder="Miejscowość" :readonly="restricted" :class="{'error': errors.includes('city')}" />
          </div>
          <div class="col-12 col-md-4" style="position: relative;">
            <input v-mask="'##-###'" v-model="postalCode" class="text-input postal-code-input"  :class="{'error': errors.includes('postalCode')}"
                   placeholder="Kod pocztowy"/>
             <button class="clearbtn" @click="postalCode = null" style="top: 6px" v-if="postalCode != null && postalCode.length">&times;</button>
          </div>

          <div v-show="customStreetEntrance" class="col-8" style="min-height: 64px; position: relative;">
            <input v-model="customStreetName" type="text"
                    :class="{'error':  errors.includes('street'), 'text-input': true, 'street-input': true}"
                   aria-label="Niestandardowa nazwa ulicy" placeholder="Niestandardowa nazwa ulicy"/>
            <button class="clearbtn" @click="customStreetName = null" v-if="customStreetName != null && customStreetName.length">&times;</button>
          </div>
          <div v-show="!customStreetEntrance" class="col-12 col-md-8" style="position: relative">
            <InputDropdown
              ref="streetInput"
              :class="{'error': errors.includes('street'), 'street-input': true}"
              :items="streets"
              v-model="street"
              placeholder="Ulica"/>
            <button class="clearbtn" @click="clearStreet" v-if="street != null && street.id">&times;</button>
          </div>

          <div class="col-12 col-md-4" v-show="customNumberEntrance">
            <input
              v-model="customNumber"
              type="text"
              :class="{'error': errors.includes('number'), 'text-input': true, 'building-input': true}"
              aria-label="Numer budynku"
              placeholder="Wpisz numer budynku"
            />

          </div>
          <div
            class="col-12 col-md-4"
            v-show="!customNumberEntrance"
          >
            <InputDropdown
              ref="numberInput"
              class="street-input"
              :items="numbers"
              v-model="number"
              :class="{'error': errors.includes('number'), 'street-input': true}"
              placeholder="Wybierz numer budynku"
            />
          </div>


          <div class="col-12">

            <label for="custom_street_checkbox">
              <input type="checkbox" id="custom_street_checkbox" v-model="customStreetEntrance">
              Nie znalazłeś swojej ulicy, wpisz ją ręcznie
              <span class="checkmark"></span>
            </label>

            <label for="custom_number_checkbox">
              <input type="checkbox" id="custom_number_checkbox" v-model="customNumberEntrance">
              Nie znalazłeś numeru swojego budynku, wpisz go ręcznie
              <span class="checkmark"></span>
            </label>
          </div>
        </div>


        <div style="text-align: right; padding-top: 0.5em">
          <button type="button" class="btn btn-outline-primary" @click="clearAll" style="float: left">
            Wyczyść formularz
          </button>
          <button type="button" class="btn btn-link" @click="closeBuildingModal">
            Anuluj
          </button>
          <button
            :disabled="saveButtonLock"
            :class="{'disabled': saveButtonLock}"
            type="button"
            class="btn btn-primary"
            @click="lockButtonAndSave"
          >
            {{ saveButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputDropdown from "@/components/common/InputDropdown";
import LocationsModel from "@/models/locations";
import CloseModalButton from "@/components/common/CloseModalButton";
import PolishAddress from "@/mixins/PolishAddress";

export default {
  name: "BuildingModal",
  mixins: [PolishAddress],
  components: {CloseModalButton, InputDropdown},

  data() {
    return {
      saveButtonLock: false,
      errors: []
    }
  },

  methods: {
    async lockButtonAndSave() {
      if (this.saveButtonLock) return;
      this.saveButtonLock = true;
      try {
        await this.saveBuilding();
      } finally {
        this.saveButtonLock = false;
      }
    },
    async saveBuilding() {
      let _errors  = [];

      if ((!this.voivodeship) || (!this.voivodeship.id))
          _errors.push('voivodeship');
      if ((!this.county) || (!this.county.id))
          _errors.push('county');
      if ((!this.community) || (!this.community.id))
          _errors.push('community');
      if ((!this.city) || (!this.city.id))
          _errors.push('city');
      if ((!this.postalCode) || (!this.postalCode.length))
          _errors.push('postalCode');
      if (!((this.customStreetEntrance) && (this.customNumberEntrance))) {
          if ((!this.customStreetEntrance) && ((!this.street) || (!this.street.id)))
              _errors.push('street');
          if ((!this.customNumberEntrance) && ((!this.number) || (!this.number.id)))
              _errors.push('number');
      }

      this.errors = _errors;

      if (_errors.length) {
        this.$notify({
          group: 'zone',
          type: 'error',
          title: 'Błąd!',
          text: 'Nie wszystkie wymagane pola zostały wypełnione'
        });
        return;
      }

      let payload = {
        postal_code: this.postalCode,
        city_id: this.city.id
      };

      if (this.customStreetEntrance) {
        payload.custom_street_name = this.customStreetName;
      } else {
        payload.street_id = this.street.id;
      }

      if (this.customNumberEntrance) {
        payload.custom_number = this.customNumber;
      } else {
        payload.number_id = this.number.id;
      }

      this.$store.commit("setCachedBuildingData", {
        'voivodeship': this.voivodeship,
        'county': this.county,
        'community': this.community,
        'city': this.city,
        'postalCode': this.postalCode,
        'street': this.street,
        'customStreetEntrance': this.customStreetEntrance,
        'customStreetName': this.customStreetName,
        'number': this.number,
        'customNumberEntrance': this.customNumberEntrance,
        'customNumber': this.customNumber
      });

      if (!this.buildingToEdit) {
        try {
          await LocationsModel.createBuilding(payload);
          this.$notify({
            group: 'zone',
            type: 'success',
            title: 'Sukces',
            text: 'Pomyślnie dodano nowy budynek'
          });
        } catch (err) {
          if (err.response && err.response.data && err.response.data.detail) {
            this.$notify({
              group: 'zone',
              type: 'error',
              title: 'Błąd!',
              text: err.response.data.detail
            });
          }
        }
      } else {
        await LocationsModel.updateBuilding(this.buildingToEdit.id, payload);
        this.$notify({
          group: 'zone',
          type: 'success',
          title: 'Sukces',
          text: 'Pomyślnie zapisano zmiany'
        });
      }
      this.closeBuildingModal();
    },
    closeBuildingModal() {
      this.$store.commit("setBuildingToEdit", null);
      this.$store.commit("closeBuildingModal");
      this.$root.$emit("reloadBuildingsIfNeeded");
    },
    clearStreet() {
      this.street = null;
      this.$refs.streetInput.reset();
    },
    clearAll() {
      this.customNumberEntrance = false;
      this.customNumber = null;
      this.number = null;
      this.$refs.numberInput.reset();
      this.customStreetEntrance = false;
      this.customStreetName = null;
      this.street = null;
      this.$refs.streetInput.reset();
      this.postalCode = null;
      this.city = null;
      this.$refs.cityInput.reset();
      this.community = null;
      this.$refs.communityInput.reset();
      this.county = null;
      this.$refs.countyInput.reset();
      this.voivodeship = null;
      this.$refs.voivodeshipInput.reset();
    }
  },

  /*
  When any field is updated clear other fields to make user provide it again
   */
  computed: {
    buildingToEdit() {
      return this.$store.state.buildingToEdit;
    },
    restricted() {
      return this.$store.state.buildingToEdit
        && ((this.$store.state.buildingToEdit.submitted_a_declarations_count + this.$store.state.buildingToEdit.submitted_b_declarations_count + this.$store.state.buildingToEdit.draft_a_declarations_count + this.$store.state.buildingToEdit.draft_b_declarations_count) > 0);
    },
    cachedBuildingData() {
      return this.$store.state.cachedBuildingData;
    },
    saveButtonText() {
      return this.buildingToEdit ? "Zapisz zmiany" : "Dodaj budynek";
    }
  }
}
</script>

<style scoped>
.zone-modal {
  height: 36rem;
}

@media screen and (max-width: 768px) {
  .zone-modal {
    -webkit-transform: none;
    transform: none;
    position: absolute;
    top: -80px;
    left: 10px;
    right: 10px;
    height: auto;
    width: auto;
  }

  .zone-modal .postal-code-input {
    margin-bottom: 0.8rem;
  }
}

.zone-modal .buttons-row {
  margin-top: 0;
}

.street-input {
  margin-right: 2%;
  float: left;
  margin-top: 0;
}


.no-street-text:hover, .no-street-text:active {
  color: #213166;
  text-decoration: underline;
  width: 68%;
}

.postal-code-input {
  margin-top: .4rem;
}

.error {
  border: 1px solid #F22;
  border-radius: .4em;
}

.clearbtn {
  position: absolute;
  right: 16px;
  top: 0;
  width: 32px;
  height: 48px;
  border: none;
  background: transparent;
  font-size: 200%;
  line-height: 52px;
  vertical-align: middle;
  color: #888;
}
</style>
